import { lazy } from 'react';
import { authRoles } from 'auth/authRoles';
import Loadable from 'ui-component/Loadable';

const Black = Loadable(lazy(() => import('./Black')));
const Create = Loadable(lazy(() => import('./Create')));
const Update = Loadable(lazy(() => import('./Update')));
const View = Loadable(lazy(() => import('./View')));

const routeTypes = [
    { path: 'black', type: 'inward' },
    { path: 'black-outward', type: 'outward' }
];

const BlackRoutes = routeTypes.flatMap(({ path, type }) => [
    {
        path: `/${path}/create`,
        element: <Create type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}`,
        element: <Black type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}/edit/:id`,
        element: <Update type={type} />,
        auth: authRoles.admin
    },
    {
        path: `/${path}/view/:id`,
        element: <View type={type} />,
        auth: authRoles.admin
    }
]);

export default BlackRoutes;